import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import { Checkbox, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs'
import { Window } from '@progress/kendo-react-dialogs'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardSubtitle,
  CardTitle,
  GridLayout,
  GridLayoutItem,
  StackLayout
} from '@progress/kendo-react-layout'
import { produce } from 'immer'

import {
  CommonActions,
  useAppDispatch
} from '../../../stores'
import { BuildingMaintenance } from '../maintenance/BuildingMaintenance'
import { BuildingSplit } from '../maintenance/BuildingSplit'
import {
  ConfirmDialog,
  ErrorMessage
} from '../../../components/parts'
import Constants from '../../../data/Constants.json'
import {
  BuildingInfo,
  BuildingInfoGet,
  BuildingInfoPut,
  BuildingInfoSplit,
  ExpenseInfo,
  GetBuildingSearchResObj,
  PutBuildingItemReqObj,
  PutExpenseItemReqObj
} from '@gateway.Building'
import { PostSimulationExecuteReqParams } from '@gateway.Simulation'
import dayjs from 'dayjs'
import { Authority } from '../../../gateway/system/Authority'
import { UserProperty } from '../../../gateway/system/UserProperty'
import { BuildingMaintenanceGateway } from '../../../gateway/building/BuildingMaintenanceGateway'
import { SimulationExecuteGateway } from '../../../gateway/simulation/SimulationExecuteGateway'
import { MessageProvider } from '../../../services'
import { BuildingHistory } from '../history/BuildingHistory'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { Marker } from '../../../components/elements'
import './BuildingSearch.css'
import { BuildingExpense } from '../maintenance/BuildingExpense'
import { ExpenseItemGateway } from '../../../gateway/building/ExpenseItemGateway'

const BUILDING_INFO_PUT_INIT: BuildingInfoPut = {
  simulationYm: null,
  buildingNo: null,
  procurementNo: null,
  subNo: null,
  branchCd: null,
  expense: null,
  expenseSeq: null,
  branchNm: null,
  constructionKbn: null,
  constructionKbnNm: null,
  constructionNm: null,
  dispConstructionNm: null,
  opportunityProgressCd: null,
  opportunityProgress: null,
  privateDecisionFlg: null,
  constructionFormCd: null,
  dispConstructionFormCd: null,
  obtainHistoryCd: null,
  dispObtainHistoryCd: null,
  evaluationCd: null,
  evaluation: null,
  evaluationValueCd: null,
  evaluationValue: null,
  customerPartnershipCd: null,
  customerCd: null,
  customerNm: null,
  dispCustomerNm: null,
  collabCustomerPartnershipCd: null,
  collabCustomerCd: null,
  collabCustomerNm: null,
  dispCollabCustomerNm: null,
  designerCustomerPartnershipCd: null,
  designerCustomerCd: null,
  designerNm: null,
  dispDesignerNm: null,
  designKbn: null,
  dispDesignKbn: null,
  designKbnNm: null,
  dispDesignKbnNm: null,
  totalCost: null,
  dispTotalCost: null,
  ourCompanyTotalCost: null,
  dispOurCompanyTotalCost: null,
  ourCompanyEquityRatio: null,
  dispOurCompanyEquityRatio: null,
  obtainYM: null,
  obtainFY: '',
  dispObtainFY: '',
  constructionSubjectCd: null,
  dispConstructionSubjectCd: null,
  constructionSectionCd: null,
  constructionSectionNm: null,
  dispConstructionSectionNm: null,
  chiefPersonCd: null,
  chiefPersonEmployeeNo: null,
  chiefPersonNm: null,
  dispChiefPersonNm: null,
  chiefPersonContacts: null,
  dispChiefPersonContacts: null,
  hqSalesSectionCd: null,
  hqSalesSectionNm: null,
  dispHqSalesSectionNm: null,
  hqSalesPersonCd: null,
  hqSalesPersonEmployeeNo: null,
  hqSalesPersonNm: null,
  dispHqSalesPersonNm: null,
  hqSalesPersonContacts: null,
  dispHqSalesPersonContacts: null,
  branchSalesSectionCd: null,
  branchSalesSectionNm: null,
  dispBranchSalesSectionNm: null,
  branchSalesPersonCd: null,
  branchSalesPersonEmployeeNo: null,
  branchSalesPersonNm: null,
  dispBranchSalesPersonNm: null,
  branchSalesPersonContacts: null,
  dispBranchSalesPersonContacts: null,
  prefecture: null,
  dispPrefecture: null,
  city: null,
  dispCity: null,
  startYM: null,
  startY: '',
  startM: '',
  dispStartYM: null,
  completionYM: null,
  completionY: '',
  completionM: '',
  dispCompletionYM: null,
  schedule: null,
  dispSchedule: null,
  planSummary: null,
  buildingServicesWorkFlg: null,
  dispBuildingServicesWorkFlg: null,
  constructionCd: null,
  dispConstructionCd: null,
  architectureUse: null,
  totalFloorAreaM2: null,
  dispTotalFloorAreaM2: null,
  totalFloorAreaTsubo: null,
  dispTotalFloorAreaTsubo: null,
  siteAreaM2: null,
  dispSiteAreaM2: null,
  siteAreaTsubo: null,
  dispSiteAreaTsubo: null,
  structureCd: null,
  structureUnderGround: null,
  dispStructureUnderGround: null,
  structureGround: null,
  dispStructureGround: null,
  structurePenthouse: null,
  dispStructurePenthouse: null,
  floorUnderGround: null,
  dispFloorUnderGround: null,
  floorGround: null,
  dispFloorGround: null,
  floorPenthouse: null,
  dispFloorPenthouse: null,
  specialConstructionMethod: null,
  dispSpecialConstructionMethod: null,
  piling: null,
  seismicIsolation: null,
  topDownFlg: null,
  fixComment: null,
  architectureUseCd1: null,
  architectureUseNm1: null,
  architectureUseCd2: null,
  architectureUseNm2: null,
  architectureUseCd3: null,
  architectureUseNm3: null,
  analyzationArchitectureUseCd1: null,
  analyzationArchitectureUseNm1: null,
  analyzationArchitectureUseCd2: null,
  analyzationArchitectureUseNm2: null,
  analyzationArchitectureUseCd3: null,
  analyzationArchitectureUseNm3: null,
  effortLevelCd: null,
  dispEffortLevelCd: null,
  effortLevel: null,
  dispEffortLevel: null,
  coreTopFlg: null,
  dispCoreTopFlg: null,
  choiceAndConcentrationTarget: null,
  dispChoiceAndConcentrationTarget: null,
  sagyosyoCd: null,
  dispSagyosyoCd: null,
  yamadumiNotApplicableYm: null,
  importDtm: null,
  addUserKbn: null,
  addDtm: null,
  addUserCd: null,
  updUserKbn: null,
  updDtm: null,
  updUserCd: null,
  delFlg: 0,
  yamadumiFlg: 0,
  kenzaiDiscloseFlg: 0,
  supplierDiscloseFlg: 0,
  completedFlg: 0,
  reportNonTargetFlg: 0,
  procurementSts: null,
  updSts: null,
  remark: null,
  modeKbn: '0'
}

const BUILDING_SEARCH_BTN_DISABLED: BuildingSearchBtnDisabled = {
  isDelBtnDisabled: false,
  isSplitBtnDisabled: false,
  isEditBtnDisabled: false,
  isHistoryBtnDisabled: false,
  isYamadumiSimulationBtnDisabled: false,
  isExpenseBtnDisabled: false,
  isYamadumiBtnDisabled: false,
  isKenzaiBtnDisabled: false,
  isSupplierBtnDisabled: false,
  isCompletedBtnDisabled: false,
  isReportNonTargetBtnDisabled: false,
  isReplaceCheckDisabled: false
}

/**
 * ボタンの活性/非活性
 */
interface BuildingSearchBtnDisabled {
  isDelBtnDisabled: boolean
  isSplitBtnDisabled: boolean
  isEditBtnDisabled: boolean
  isHistoryBtnDisabled: boolean
  isYamadumiSimulationBtnDisabled: boolean
  isExpenseBtnDisabled: boolean
  /** 山積対象（トグル） */
  isYamadumiBtnDisabled: boolean
  /** 建材部公開（トグル） */
  isKenzaiBtnDisabled: boolean
  /** 業者公開（トグル） */
  isSupplierBtnDisabled: boolean
  /** 竣工済（トグル） */
  isCompletedBtnDisabled: boolean
  /** 帳票対象外（トグル） */
  isReportNonTargetBtnDisabled: boolean
  /** 付替チェックボックス */
  isReplaceCheckDisabled: boolean
}

interface BuildingSearchCardProps {
  isSupplier: boolean
  buildingInfo: BuildingInfoGet
  userProp?: UserProperty
  allowBuildingSplit: number | null
  updDtmBuildingHistoryStatus: string | null
  onSearchBtnClick: () => void
  setBuildingSearchData: Dispatch<SetStateAction<GetBuildingSearchResObj>>
  setOkButtonDisabled: Dispatch<SetStateAction<boolean>>
  setNotificationMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  setErrorMessages: Dispatch<SetStateAction<ErrorMessage[]>>
  buildingSearchDataState: GetBuildingSearchResObj
  setIsChanged: Dispatch<React.SetStateAction<boolean>>
  buildingSearchDataStore: GetBuildingSearchResObj
  setBuildingSearchDataState: React.Dispatch<React.SetStateAction<GetBuildingSearchResObj>>
  target: string
  setTarget: Dispatch<SetStateAction<string>>
  sourceBuilding: string
  setSourceBuilding: Dispatch<SetStateAction<string>>
  destinationBuilding: string
  setDestinationBuilding: Dispatch<SetStateAction<string>>
}

export const BuildingSearchCard: FC<BuildingSearchCardProps> = ({
  isSupplier,
  buildingInfo,
  userProp,
  allowBuildingSplit,
  updDtmBuildingHistoryStatus,
  onSearchBtnClick,
  setBuildingSearchData,
  setOkButtonDisabled,
  setNotificationMessages,
  setErrorMessages,
  buildingSearchDataState,
  setIsChanged,
  buildingSearchDataStore,
  setBuildingSearchDataState,
  target,
  setTarget,
  sourceBuilding,
  setSourceBuilding,
  destinationBuilding,
  setDestinationBuilding
}) => {
  const dispatch = useAppDispatch()

  const [showMaintenanceDialog, setShowMaintenanceDialog] = useState(false)
  const [showSplitDialog, setShowSplitDialog] = useState(false)
  const [showHistoryDialog, setShowHistoryDialog] = useState(false)
  const [showExpenseDialog, setShowExpenseDialog] = useState(false)

  const [yamadumiTarget, setYamadumiTarget] = useState(
    buildingInfo.yamadumiFlg === 1
  )
  const [publishToKenzaibu, setPublishToKenzaibu] = useState(
    buildingInfo.kenzaiDiscloseFlg === 1
  )
  const [publishTofabricator, setPublishTofabricator] = useState(
    buildingInfo.supplierDiscloseFlg === 1
  )
  const [completed, setCompleted] = useState(
    buildingInfo.completedFlg === 1
  )
  const [reportNonTarget, setReportNonTarget] = useState(
    buildingInfo.reportNonTargetFlg === 1
  )
  const createCopyBuildingInfoExceptYamadumiFlg = (v: BuildingInfo) => {
    const copy = Object.assign({}, JSON.parse(JSON.stringify(v)))
    delete copy.kenzaiDiscloseFlg
    delete copy.supplierDiscloseFlg
    return copy
  }
  const createCopyBuildingInfoExceptKenzaiDiscloseFlg = (v: BuildingInfo) => {
    const copy = Object.assign({}, JSON.parse(JSON.stringify(v)))
    delete copy.yamadumiFlg
    delete copy.supplierDiscloseFlg
    return copy
  }
  const createCopyBuildingInfoExceptSupplierDiscloseFlg = (v: BuildingInfo) => {
    const copy = Object.assign({}, JSON.parse(JSON.stringify(v)))
    delete copy.yamadumiFlg
    delete copy.kenzaiDiscloseFlg
    return copy
  }
  const [copyBuildingInfoExceptYamadumiFlg, setCopyBuildingInfoExceptYamadumiFlg] = useState<BuildingInfo>(
    () => {
      return createCopyBuildingInfoExceptYamadumiFlg(buildingInfo)
    }
  )
  const [copyBuildingInfoExceptKenzaiDiscloseFlg, setCopyBuildingInfoExceptKenzaiDiscloseFlg] = useState<BuildingInfo>(
    () => {
      return createCopyBuildingInfoExceptKenzaiDiscloseFlg(buildingInfo)
    }
  )
  const [copyBuildingInfoExceptSupplierDiscloseFlg, setCopyBuildingInfoExceptSupplierDiscloseFlg] = useState<BuildingInfo>(
    () => {
      return createCopyBuildingInfoExceptSupplierDiscloseFlg(buildingInfo)
    }
  )

  const [buildingSearchBtnDisabled, setBuildingSearchBtnDisabled] = useState<BuildingSearchBtnDisabled>(BUILDING_SEARCH_BTN_DISABLED)
  // 物件情報編集の保持領域
  const [buildingInfoPutState, setBuildingInfoPutState] = useState<BuildingInfoPut>(BUILDING_INFO_PUT_INIT)
  // 編集対象の物件情報の内容
  const [buildingInfoPutStore, setBuildingInfoPutStore] = useState<BuildingInfoPut>(BUILDING_INFO_PUT_INIT)
  const [buildingMaintenanceSignInBtnDisabled, setBuildingMaintenanceSignInBtnDisabled] = useState(false)
  const [buildingInfoSplitListState, setBuildingInfoSplitListState] = useState<BuildingInfoSplit[]>([])

  const [expenseInfoPutState, setExpenseInfoPutState] = useState<ExpenseInfo[]>([])

  /** 親物件、子物件、費目分割物件の表示方法 */
  const paddingLeft = () => {
    if (buildingInfo.subNo === '00') {
      return 0
    }
    if (buildingInfo.subNo !== '00') {
      return 30
    }
  }

  const isExpanded = ((buildingSearchDataState.buildingInfoList
    .find((item) =>
      item.buildingInfo.procurementNo === buildingInfo.procurementNo &&
      item.buildingInfo.subNo === buildingInfo.subNo)
    ?.buildingInfo.isExpanded) ?? false)

  // 表示フラグ(展開済の子物件のみ表示)
  const isDisplay = isExpanded || buildingInfo.subNo === '00'

  // 子物件が存在するかのフラグ
  const isExistChildren = buildingSearchDataState.buildingInfoList
    .filter((item) => item.buildingInfo.procurementNo === buildingInfo.procurementNo).length > 1

  // 費目の表示文字列
  let expenseString = null
  if (buildingInfo.expenseInfos !== null) {
    expenseString =
      [...buildingInfo.expenseInfos]
        ?.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        .filter(ex => ex.expenseNotApplicableFlg === 1)
        .map(ex => ex.expenseName).join(', ')
  }

  const toggleSplitDialog = () => {
    setShowSplitDialog(!showSplitDialog)
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const toggleMaintenanceDialog = () => {
    setShowMaintenanceDialog(!showMaintenanceDialog)
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const toggleHistoryDialog = () => {
    setShowHistoryDialog(!showHistoryDialog)
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const toggleExpenseDialog = () => {
    setShowExpenseDialog(!showExpenseDialog)
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  /**
   * オブジェクト比較
   * （変更なし：true, 変更あり：false）
   */
  const ObjCompare = (obj1: BuildingInfoPut, obj2: BuildingInfoPut) => {
    const obj1Keys = Object.keys(obj1) as Array<keyof BuildingInfoPut>
    const obj2Keys = Object.keys(obj2) as Array<keyof BuildingInfoPut>
    if (obj1Keys.length !== obj2Keys.length) {
      return false
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    for (const k of obj1Keys as Array<keyof BuildingInfoPut>) {
      if (obj1[k] !== obj2[k]) {
        return false
      }
    }
    return true
  }

  /**
   * 費目要否比較
   * （変更なし：true, 変更あり：false）
   */
  const ExpenseCompare = () => {
    return (
      // 費目要否が存在しない（自動計算が行われていない）場合
      buildingInfo.expenseInfos === null ||
      // 費目要否の変更が一切行われていない（初期値と現在値の費目要否の値が異なる費目が存在しない）場合
      !buildingInfo.expenseInfos.some(ex => expenseInfoPutState.find(exs => exs.expenseCode === ex.expenseCode)?.expenseNotApplicableFlg !== ex.expenseNotApplicableFlg)
    )
  }

  // 子物件を含め展開済にする
  const handleExpand = () => {
    setBuildingSearchDataState(produce((draft) => {
      draft.buildingInfoList.forEach((obj) => {
        if (obj.buildingInfo.procurementNo === buildingInfo.procurementNo) {
          obj.buildingInfo.isExpanded = !obj.buildingInfo.isExpanded
        }
      })
    }))
  }

  const updateBuildingSearchData = (key: string, val: boolean, ChangeSingle: boolean) => {
    setBuildingSearchData(
      produce((draft) => {
        draft.buildingInfoList.forEach((obj) => {
          if (
            obj.buildingInfo.procurementNo === buildingInfo.procurementNo &&
            obj.buildingInfo.subNo === buildingInfo.subNo
          ) {
            const store = buildingSearchDataStore.buildingInfoList.find(
              v => v.buildingInfo.procurementNo === buildingInfo.procurementNo && v.buildingInfo.subNo === buildingInfo.subNo
            )
            // 山積対象
            if (key === 'yamadumiFlg') {
              obj.buildingInfo.yamadumiFlg = Number(val)
              if (ChangeSingle) {
                // 他のフラグの変更との同期のための変更ではない場合
                obj.buildingInfo.isChanged = store?.buildingInfo.yamadumiFlg !== Number(val)
              }
            }
            // 建材部公開
            if (key === 'kenzaiDiscloseFlg') {
              obj.buildingInfo.kenzaiDiscloseFlg = Number(val)
              if (ChangeSingle) {
                // 他のフラグの変更との同期のための変更ではない場合
                obj.buildingInfo.isChanged = store?.buildingInfo.kenzaiDiscloseFlg !== Number(val)
              }
            }
            // 業者公開
            if (key === 'supplierDiscloseFlg') {
              obj.buildingInfo.supplierDiscloseFlg = Number(val)
              if (ChangeSingle) {
                // 他のフラグの変更との同期のための変更ではない場合
                obj.buildingInfo.isChanged = store?.buildingInfo.supplierDiscloseFlg !== Number(val)
              }
            }
            // 竣工済
            if (key === 'completedFlg') {
              obj.buildingInfo.completedFlg = Number(val)
              if (ChangeSingle) {
                // 他のフラグの変更との同期のための変更ではない場合
                obj.buildingInfo.isChanged = store?.buildingInfo.completedFlg !== Number(val)
              }
            }
            // 帳票対象外
            if (key === 'reportNonTargetFlg') {
              obj.buildingInfo.reportNonTargetFlg = Number(val)
              if (ChangeSingle) {
                // 他のフラグの変更との同期のための変更ではない場合
                obj.buildingInfo.isChanged = store?.buildingInfo.reportNonTargetFlg !== Number(val)
              }
            }
          }
        })
      })
    )
  }

  /**
   * 確定ボタンが活性になっている条件
   * @param event
   * @returns boolean
   */
  const isOkButtonDisabled = (key: string, event: SwitchChangeEvent) => {
    // ※確定ボタンが活性になっている条件：利用者権限≠ 業者、かついずれかの物件情報明細部のM1山積対象、
    // M1建材部公開、M1業者公開のいずれかがデータ取得時から変化している
    if (!isSupplier) {
      const flagValue = Number(event.value)
      let isActivated = false
      for (let i = 0; i < buildingSearchDataStore.buildingInfoList.length; i++) {
        const obj = buildingSearchDataStore.buildingInfoList[i]

        const originYamadumiFlg = obj.buildingInfo.yamadumiFlg
        const originKenzaiDiscloseFlg = obj.buildingInfo.kenzaiDiscloseFlg
        const originSupplierDiscloseFlg = obj.buildingInfo.supplierDiscloseFlg
        const originCompletedFlg = obj.buildingInfo.completedFlg
        const originReportNonTargetFlg = obj.buildingInfo.reportNonTargetFlg

        const stateYamadumiFlg =
          buildingSearchDataState.buildingInfoList[i].buildingInfo.yamadumiFlg
        const stateKenzaiDiscloseFlg =
          buildingSearchDataState.buildingInfoList[i].buildingInfo.kenzaiDiscloseFlg
        const stateSupplierDiscloseFlg =
          buildingSearchDataState.buildingInfoList[i].buildingInfo.supplierDiscloseFlg
        const stateCompletedFlg =
          buildingSearchDataState.buildingInfoList[i].buildingInfo.completedFlg
        const stateReportNonTargetFlg =
          buildingSearchDataState.buildingInfoList[i].buildingInfo.reportNonTargetFlg

        if (
          obj.buildingInfo.procurementNo === buildingInfo.procurementNo &&
          obj.buildingInfo.subNo === buildingInfo.subNo
        ) {
          // 山積対象
          if (key === 'yamadumiFlg') {
            isActivated =
              originKenzaiDiscloseFlg !== stateKenzaiDiscloseFlg ||
              originSupplierDiscloseFlg !== stateSupplierDiscloseFlg ||
              originCompletedFlg !== stateCompletedFlg ||
              originReportNonTargetFlg !== stateReportNonTargetFlg ||
              originYamadumiFlg !== flagValue
          }
          // 建材部公開
          if (key === 'kenzaiDiscloseFlg') {
            isActivated =
              originSupplierDiscloseFlg !== stateSupplierDiscloseFlg ||
              originYamadumiFlg !== stateYamadumiFlg ||
              originCompletedFlg !== stateCompletedFlg ||
              originReportNonTargetFlg !== stateReportNonTargetFlg ||
              originKenzaiDiscloseFlg !== flagValue
          }
          // 業者公開
          if (key === 'supplierDiscloseFlg') {
            isActivated =
              originYamadumiFlg !== stateYamadumiFlg ||
              originKenzaiDiscloseFlg !== stateKenzaiDiscloseFlg ||
              originCompletedFlg !== stateCompletedFlg ||
              originReportNonTargetFlg !== stateReportNonTargetFlg ||
              originSupplierDiscloseFlg !== flagValue
          }
          // 竣工済
          if (key === 'completedFlg') {
            isActivated =
              originYamadumiFlg !== stateYamadumiFlg ||
              originKenzaiDiscloseFlg !== stateKenzaiDiscloseFlg ||
              originSupplierDiscloseFlg !== stateSupplierDiscloseFlg ||
              originReportNonTargetFlg !== stateReportNonTargetFlg ||
              originCompletedFlg !== flagValue
          }
          // 帳票対象外
          if (key === 'reportNonTargetFlg') {
            isActivated =
              originYamadumiFlg !== stateYamadumiFlg ||
              originKenzaiDiscloseFlg !== stateKenzaiDiscloseFlg ||
              originSupplierDiscloseFlg !== stateSupplierDiscloseFlg ||
              originCompletedFlg !== stateCompletedFlg ||
              originReportNonTargetFlg !== flagValue
          }
        } else {
          isActivated =
            originYamadumiFlg !== stateYamadumiFlg ||
            originKenzaiDiscloseFlg !== stateKenzaiDiscloseFlg ||
            originSupplierDiscloseFlg !== stateSupplierDiscloseFlg ||
            originCompletedFlg !== stateCompletedFlg ||
            originReportNonTargetFlg !== stateReportNonTargetFlg
        }

        if (isActivated) {
          break
        }
      }
      return !isActivated
    }
    return true
  }

  const toggleYamadumiTarget = (event: SwitchChangeEvent) => {
    setIsChanged(true)
    setYamadumiTarget(event.value)
    // ステートに同期
    updateBuildingSearchData('yamadumiFlg', event.value, true)
    // 確定ボタンが活性になっている条件
    setOkButtonDisabled(isOkButtonDisabled('yamadumiFlg', event))
    if (!event.value) {
      // 山積対象フラグのOFFは建材部公開フラグに同期させる
      setPublishToKenzaibu(event.value)
      // ステートに同期
      updateBuildingSearchData('kenzaiDiscloseFlg', event.value, false)
    }
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const togglePublishToKenzaibu = (event: SwitchChangeEvent) => {
    setIsChanged(true)
    setPublishToKenzaibu(event.value)
    // ステートに同期
    updateBuildingSearchData('kenzaiDiscloseFlg', event.value, true)
    // 確定ボタンが活性になっている条件
    setOkButtonDisabled(isOkButtonDisabled('kenzaiDiscloseFlg', event))
    if (event.value) {
      // 建材部公開フラグのONは山積対象フラグに同期させる
      setYamadumiTarget(event.value)
      // ステートに同期
      updateBuildingSearchData('yamadumiFlg', event.value, false)
    }
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const handlePublishTofabricatorToggle = (event: SwitchChangeEvent) => {
    setIsChanged(true)
    setPublishTofabricator(event.value)
    // ステートに同期
    updateBuildingSearchData('supplierDiscloseFlg', event.value, true)

    // 確定ボタンが活性になっている条件
    setOkButtonDisabled(isOkButtonDisabled('supplierDiscloseFlg', event))

    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const ToggleCompleted = (event: SwitchChangeEvent) => {
    setIsChanged(true)
    setCompleted(event.value)
    // ステートに同期
    updateBuildingSearchData('completedFlg', event.value, true)

    // 確定ボタンが活性になっている条件
    setOkButtonDisabled(isOkButtonDisabled('completedFlg', event))

    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const ToggleReportNonTarget = (event: SwitchChangeEvent) => {
    setIsChanged(true)
    setReportNonTarget(event.value)
    // ステートに同期
    updateBuildingSearchData('reportNonTargetFlg', event.value, true)

    // 確定ボタンが活性になっている条件
    setOkButtonDisabled(isOkButtonDisabled('reportNonTargetFlg', event))

    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  const styleCardHeader = isSupplier
    ? { padding: '1% 1%', width: '15%' }
    : { padding: '0.8% 1%', width: '15%' }

  const styleCardBody = isSupplier
    ? { padding: '1% 1%', width: '65%' }
    : { padding: '0.8% 1%', width: '65%' }

  // Dialog
  const [confirmDialogShow, setConfirmDialogShow] = useState(false)
  const [title, setTitle] = useState('')
  const [args, setArgs] = useState([''])
  const [confirmDialogId, setConfirmDialogId] = useState('')
  const [confirmDialogType, setConfirmDialogType] = useState('')

  /** 物件情報編集の登録 */
  const toggleMaintenanceDialogLogin = () => {
    setConfirmDialogShow(true)
    setTitle('物件情報編集の登録')
    setArgs(['物件情報', '登録'])
    setConfirmDialogId('I002')
  }

  /** 編集画面での戻る */
  const toggleMaintenanceDialogReturn = () => {
    const diff = ObjCompare(buildingInfoPutStore, buildingInfoPutState)
    if (!diff) {
      setConfirmDialogShow(true)
      setTitle('確認')
      setConfirmDialogId('I003')
      setConfirmDialogType('maintenance')
    } else {
      toggleMaintenanceDialog()
    }
  }

  /** 物件情報分割の登録 */
  const toggleSplitDialogLogin = () => {
    setConfirmDialogShow(true)
    setTitle('物件情報分割の登録')
    setArgs(['物件情報', '登録'])
    setConfirmDialogId('I002')
  }

  /**
   * 分割画面での戻る
   */
  const toggleSplitDialogReturn = () => {
    if (buildingInfoSplitListState.length !== 0) {
      setConfirmDialogShow(true)
      setTitle('確認')
      setConfirmDialogId('I003')
      setConfirmDialogType('split')
    } else {
      toggleSplitDialog()
    }
  }

  /** 削除dialog */
  const handleDelete = () => {
    setConfirmDialogShow(true)
    setTitle('物件情報の削除')
    setConfirmDialogId('I014')
    setArgs([`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`])
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  /** 山積シミュレーションdialog */
  const handleYamadumiSimulation = () => {
    setConfirmDialogShow(true)
    setTitle('物件情報の山積シミュレーション')
    setConfirmDialogId('I007')
    setArgs([`対象物件(${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''})の山積シミュレーション`])
    setTarget(`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`)
  }

  /** 物件情報費目要否の登録 */
  const toggleExpenseDialogLogin = () => {
    setConfirmDialogShow(true)
    setTitle('物件情報費目要否の登録')
    setArgs(['物件情報費目要否', '登録'])
    setConfirmDialogId('I002')
  }

  /** 費目要否画面での戻る */
  const toggleExpenseDialogReturn = () => {
    const diff = ExpenseCompare()
    if (!diff) {
      setConfirmDialogShow(true)
      setTitle('確認')
      setConfirmDialogId('I003')
      setConfirmDialogType('expense')
    } else {
      toggleExpenseDialog()
    }
  }

  /** dialog 確認ボタン */
  const handleConfirmEvent = () => {
    setConfirmDialogShow(false)
    if (title === '物件情報編集の登録' || title === '物件情報分割の登録' || title === '物件情報の削除') {
      dispatch(CommonActions.setIsLoading(true))
      const args: string[] = []
      const putBuildingItemReqObj: PutBuildingItemReqObj = {
        data: {
          buildingInfoList: []
        }
      }
      if (title === '物件情報編集の登録') {
        const buildingInfoPut = { ...buildingInfoPutState }
        // シミュレーション年月度
        buildingInfoPut.simulationYm = ''
        // 費目
        buildingInfoPut.expense = ''
        // 費目連番
        buildingInfoPut.expenseSeq = ''

        // 各フラグはストアが更新されている可能性があるため、検索処理での取得時点の状態を設定
        // 山積対象フラグ
        buildingInfoPut.yamadumiFlg = buildingInfo.yamadumiFlg
        // 建材部公開フラグ
        buildingInfoPut.kenzaiDiscloseFlg = buildingInfo.kenzaiDiscloseFlg
        // 業者公開フラグ
        buildingInfoPut.supplierDiscloseFlg = buildingInfo.supplierDiscloseFlg

        putBuildingItemReqObj.data.buildingInfoList.push({
          buildingInfo: buildingInfoPut,
          flgChg: 0,
          updDtmParentBuildingHistoryStatus: null,
          updDtmBuildingHistoryStatus
        })
        args.push('物件情報の登録')
      } else if (title === '物件情報分割の登録') {
        const buildingInfoSplitList: BuildingInfoSplit[] = []
        buildingInfoSplitListState.forEach((buildingInfoSplit) => {
          const splitObj = Object.assign({}, JSON.parse(JSON.stringify(buildingInfoSplit)))

          splitObj.buildingInfo.updDtm = null
          splitObj.buildingInfo.subNo = null
          splitObj.buildingInfo.updSts = null
          splitObj.buildingInfo.procurementNo = buildingInfo.procurementNo

          if (userProp?.authority === Authority.Material || userProp?.authority === Authority.Branch) {
            // 利用者の権限＝建材部または支店の場合
            // 山積対象フラグと建材部公開フラグ
            splitObj.buildingInfo.yamadumiFlg = 1
            splitObj.buildingInfo.kenzaiDiscloseFlg = 1
          }

          splitObj.updDtmParentBuildingHistoryStatus = updDtmBuildingHistoryStatus ?? null

          buildingInfoSplitList.push(splitObj)
        })
        putBuildingItemReqObj.data.buildingInfoList = buildingInfoSplitList
        args.push('物件情報の登録')
      } else if (title === '物件情報の削除') {
        const buildingInfoPut = Object.assign({}, JSON.parse(JSON.stringify(BUILDING_INFO_PUT_INIT)))
        // 調達番号 procurementNo
        buildingInfoPut.procurementNo = buildingInfo.procurementNo
        // 枝番（子） subNo
        buildingInfoPut.subNo = buildingInfo.subNo
        // 表示用工事名 dispConstrunctionNm
        buildingInfoPut.dispConstructionNm = buildingInfo.dispConstructionNm
        // 支店コード branchCd
        buildingInfoPut.branchCd = buildingInfo.branchCd
        // 削除フラグ delFlg
        buildingInfoPut.delFlg = 1
        // 更新日時 updDtm
        buildingInfoPut.updDtm = buildingInfo.updDtm

        putBuildingItemReqObj.data.buildingInfoList.push({
          buildingInfo: buildingInfoPut,
          flgChg: 0,
          updDtmBuildingHistoryStatus,
          updDtmParentBuildingHistoryStatus: null
        })
        args.push('物件情報の削除')
      }
      setBuildingSearchBtnDisabled(
        produce((draft) => {
          draft.isDelBtnDisabled = true
        })
      )
      let error = false
      BuildingMaintenanceGateway.putBuildingItem(putBuildingItemReqObj)
        .then((_res) => {
          error = _res.error
          if (!error) {
            const autoYamadumiNotPossibleBuildingList = _res.data.autoYamadumiNotPossibleBuildingList
            if (autoYamadumiNotPossibleBuildingList.length > 0) {
              const requiredLackList: string[] = []
              const mismatchList: string[] = []
              for (const autoYamadumiNotPossibleBuilding of autoYamadumiNotPossibleBuildingList) {
                const { requiredLackBuildingList, mismatchBuildingList } = autoYamadumiNotPossibleBuilding
                if (requiredLackBuildingList.length > 0) {
                  requiredLackBuildingList.forEach((item) => {
                    requiredLackList.push(`${item.procurementNo}-${item.subNo}`)
                  })
                }
                if (mismatchBuildingList.length > 0) {
                  mismatchBuildingList.forEach((item) => {
                    mismatchList.push(`${item.procurementNo}-${item.subNo}`)
                  })
                }
              }
              if (requiredLackList.length > 0 && mismatchList.length > 0) {
                setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  },
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length > 0 && mismatchList.length === 0) {
                setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length > 0) {
                setErrorMessages([
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length === 0) {
                setNotificationMessages([
                  {
                    id: 'I004',
                    content: MessageProvider.provide('I004', ...args)
                  }
                ])
              }
              if (title === '物件情報編集の登録') {
                setShowMaintenanceDialog(!showMaintenanceDialog)
              }
              if (title === '物件情報分割の登録') {
                setShowSplitDialog(!showSplitDialog)
              }
            } else {
              setNotificationMessages([
                {
                  id: 'I004',
                  content: MessageProvider.provide('I004', ...args)
                }
              ])
              if (title === '物件情報編集の登録') {
                setShowMaintenanceDialog(!showMaintenanceDialog)
              }
              if (title === '物件情報分割の登録') {
                setShowSplitDialog(!showSplitDialog)
              }
            }
          } else {
            const resMessages = _res.messages
            if (Array.isArray(resMessages) && resMessages.length > 0) {
              const notificationMessages = resMessages.map<ErrorMessage>((message: any) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(notificationMessages)
            }
          }
        })
        .finally(() => {
          setBuildingSearchBtnDisabled(
            produce((draft) => {
              draft.isDelBtnDisabled = false
            })
          )
          dispatch(CommonActions.setIsLoading(false))
          if (!error) {
            // エラーではない場合、Storeにある検索条件で物件情報の再検索を行う
            onSearchBtnClick()
          }
        })
    }
    if (title === '確認' && confirmDialogType === 'split') {
      toggleSplitDialog()
    } else if (title === '確認' && confirmDialogType === 'maintenance') {
      toggleMaintenanceDialog()
    } else if (title === '確認' && confirmDialogType === 'expense') {
      toggleExpenseDialog()
    }
    if (title === '物件情報の山積シミュレーション') {
      dispatch(CommonActions.setIsLoading(true))

      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      // クエリパラメータ
      const reqParams: PostSimulationExecuteReqParams = {
        execInfo: {
          branch: [buildingInfo.branchCd ?? ''],
          simulationYm: `${year}${month}`,
          execMode: '1'
        },
        buildingInfo: {
          procurementNo: buildingInfo.procurementNo ?? undefined,
          subNo: buildingInfo.subNo ?? undefined
        }
      }

      let isSuccess: boolean = true
      SimulationExecuteGateway.postSimulationExecute(reqParams)
        .then((res) => {
          if (res.error) {
            // errorの場合
            isSuccess = false
            const resMessages = res.messages
            if (Array.isArray(resMessages) && resMessages.length > 0) {
              const messages = resMessages.map<ErrorMessage>((message) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(messages)
            }
          }
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
          if (isSuccess) {
            // Notificationを表示する
            setNotificationMessages([
              {
                id: 'I017',
                content: MessageProvider.provide('I017', '自動山積計算')
              }
            ])
          }
        })
    }
    if (title === '物件情報費目要否の登録') {
      dispatch(CommonActions.setIsLoading(true))

      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')

      // 初期値から変更のある費目要否のみ抽出
      const targetExpenseInfos = expenseInfoPutState.filter(ex => buildingInfo.expenseInfos?.find(exs => exs.expenseCode === ex.expenseCode)?.expenseNotApplicableFlg !== ex.expenseNotApplicableFlg)

      // クエリパラメータ
      const reqParams: PutExpenseItemReqObj = {
        data: {
          simulationYm: `${year}${month}`,
          procurementNo: buildingInfo.procurementNo ?? '',
          subNo: buildingInfo.subNo ?? '',
          branchCd: buildingInfo.branchCd ?? '',
          expenseInfos: targetExpenseInfos ?? []
        }
      }

      let isSuccess: boolean = true
      ExpenseItemGateway.putExpenseItem(reqParams)
        .then((res) => {
          if (res.error) {
            // errorの場合
            isSuccess = false
            const resMessages = res.messages
            if (Array.isArray(resMessages) && resMessages.length > 0) {
              const messages = resMessages.map<ErrorMessage>((message) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(messages)
            }
          }
        })
        .finally(() => {
          dispatch(CommonActions.setIsLoading(false))
          if (isSuccess) {
            toggleExpenseDialog()
            // Notificationを表示する
            setNotificationMessages([
              {
                id: 'I004',
                content: MessageProvider.provide('I004', '物件情報費目要否の登録')
              }
            ])
            // Storeにある検索条件で物件情報の再検索を行う
            onSearchBtnClick()
          }
        })
    }
  }

  const getItemColor = (diffFlg: number | null) => {
    if (diffFlg === null || diffFlg === undefined || diffFlg === 0) {
      return 'gray'
    }
    return '#D0611E'
  }

  const getUpdStsStrColor = () => {
    if (buildingInfo.updStsStr === '新規') {
      return '#ff0000'
    }
    if (buildingInfo.updStsStr === '更新') {
      return '#D0611E'
    }
    return 'gray'
  }

  const convertFlagValue = (category: string, val: number | null) => {
    if (category === undefined || val === undefined || val === null) {
      return ' '
    }
    if (
      category === 'piling' ||
      category === 'seismicIsolation' ||
      category === 'buildingServicesWorkFlg' ||
      category === 'coreTopFlg' ||
      category === 'choiceAndConcentrationTarget'
    ) {
      return Constants.presenceFlag.find((obj) => obj.code === String(val))
        ?.name
    }
    if (category === 'topDown') {
      return Constants.topdownFlag.find((obj) => obj.code === String(val))?.name
    }
    return ''
  }

  const checkBuilding = (buildingInfo: BuildingInfoGet, building: string): boolean => {
    const [procurementNo, subNo] = building.split('_')
    return buildingInfo.procurementNo === procurementNo && buildingInfo.subNo === subNo
  }

  const handleCheckBuilding = (buildingInfo: BuildingInfoGet, targetState: 'sourceBuilding' | 'destinationBuilding', checked: boolean) => {
    setIsChanged(true)
    const building = `${buildingInfo.procurementNo ?? ''}_${buildingInfo.subNo ?? ''}_${buildingInfo.updDtm ?? ''}`

    if (checked) {
      if (targetState === 'sourceBuilding') {
        setSourceBuilding(building)
      } else if (targetState === 'destinationBuilding') {
        setDestinationBuilding(building)
      }
    } else {
      if (targetState === 'sourceBuilding') {
        setSourceBuilding('')
      } else if (targetState === 'destinationBuilding') {
        setDestinationBuilding('')
      }
    }
  }

  useEffect(() => {
    setBuildingSearchBtnDisabled(
      produce((draft) => {
        // 物件情報タイプの決定方法
        let buildingInfoType = ''
        if (buildingInfo.addUserKbn === String(Authority.System)) {
          // 物件情報.枝番（子）='00'
          if (buildingInfo.subNo === '00') {
            buildingInfoType = '取込物件'
          }
        } else if (buildingInfo.addUserKbn === String(Authority.Builder)) {
          if (buildingInfo.subNo === '00') {
            buildingInfoType = '工務登録物件'
          } else {
            buildingInfoType = '工務分割物件'
          }
        } else if (buildingInfo.addUserKbn === String(Authority.Material)) {
          if (buildingInfo.subNo === '00') {
            buildingInfoType = '建材部登録物件'
          }
        } else if (buildingInfo.addUserKbn === String(Authority.Branch)) {
          if (buildingInfo.subNo === '00') {
            buildingInfoType = '支店登録物件'
          } else {
            buildingInfoType = '支店分割物件'
          }
        }
        // ログイン情報．利用者権限＝工務（コード＝2）の場合
        if (userProp?.authority === Authority.Builder) {
          // buildingInfoType === '工務登録物件' ||
          // buildingInfoType === '建材部登録物件' ||
          // buildingInfoType === '支店登録物件'の場合、以下の値を使用する
          draft.isDelBtnDisabled = false
          draft.isEditBtnDisabled = false
          draft.isSplitBtnDisabled = false
          draft.isHistoryBtnDisabled = false
          draft.isYamadumiSimulationBtnDisabled = buildingInfo.yamadumiFlg !== 1 || buildingInfo.kenzaiDiscloseFlg !== 1
          draft.isExpenseBtnDisabled = false
          draft.isYamadumiBtnDisabled = false
          draft.isKenzaiBtnDisabled = false
          draft.isSupplierBtnDisabled = false
          draft.isCompletedBtnDisabled = false
          draft.isReportNonTargetBtnDisabled = false
          draft.isReplaceCheckDisabled = false
          if (buildingInfoType === '取込物件') {
            // 削除（ボタン）非活性
            draft.isDelBtnDisabled = true
          }
          if (
            buildingInfoType === '工務分割物件' ||
            buildingInfoType === '支店分割物件'
          ) {
            // 分割（ボタン） 非活性
            draft.isSplitBtnDisabled = true
          }
        }

        // ログイン情報．利用者権限＝建材部（コード＝3）の場合
        if (userProp?.authority === Authority.Material) {
          // uildingInfoType === '取込物件' ||
          // buildingInfoType === '工務登録物件' ||
          // buildingInfoType === '工務分割物件' ||
          // buildingInfoType === '支店登録物件' ||
          // buildingInfoType === '支店分割子物件'の場合、以下の値を使用する
          draft.isDelBtnDisabled = true
          draft.isEditBtnDisabled = false
          draft.isSplitBtnDisabled = true
          draft.isHistoryBtnDisabled = false
          draft.isYamadumiSimulationBtnDisabled = true
          draft.isExpenseBtnDisabled = true
          draft.isYamadumiBtnDisabled = true
          draft.isKenzaiBtnDisabled = true
          draft.isSupplierBtnDisabled = true
          draft.isCompletedBtnDisabled = true
          draft.isReportNonTargetBtnDisabled = true
          draft.isReplaceCheckDisabled = true

          if (buildingInfoType === '建材部登録物件') {
            // 削除（ボタン）活性
            draft.isDelBtnDisabled = false
          }
        }

        // ログイン情報．利用者権限＝支店（コード＝4）の場合
        if (userProp?.authority === Authority.Branch) {
          // 物件情報．支店コード＝ログイン情報．支店コード
          if (buildingInfo.branchCd === userProp?.branchCode) {
            // uildingInfoType === '建材部登録物件' ||
            // buildingInfoType === '工務登録物件' ||
            // buildingInfoType === '工務分割物件' 'の場合、以下の値を使用する
            draft.isDelBtnDisabled = true
            draft.isSplitBtnDisabled = true
            draft.isEditBtnDisabled = false
            draft.isHistoryBtnDisabled = false
            draft.isYamadumiSimulationBtnDisabled = true
            draft.isExpenseBtnDisabled = true
            draft.isYamadumiBtnDisabled = true
            draft.isKenzaiBtnDisabled = true
            draft.isSupplierBtnDisabled = true
            draft.isCompletedBtnDisabled = true
            draft.isReportNonTargetBtnDisabled = true
            draft.isReplaceCheckDisabled = true

            if (buildingInfoType === '支店登録物件') {
              // すべてボタンが 活性に変更される
              draft.isDelBtnDisabled = false
              draft.isSplitBtnDisabled = false
              draft.isEditBtnDisabled = false
              draft.isHistoryBtnDisabled = false
              draft.isYamadumiSimulationBtnDisabled = buildingInfo.yamadumiFlg !== 1 || buildingInfo.kenzaiDiscloseFlg !== 1
              draft.isExpenseBtnDisabled = true
              draft.isYamadumiBtnDisabled = false
              draft.isKenzaiBtnDisabled = false
              draft.isSupplierBtnDisabled = false
              draft.isCompletedBtnDisabled = false
              draft.isReportNonTargetBtnDisabled = false
            }
            if (buildingInfoType === '支店分割物件') {
              // 分割ボタン以外が 活性に変更される
              draft.isDelBtnDisabled = false
              draft.isSplitBtnDisabled = true
              draft.isEditBtnDisabled = false
              draft.isHistoryBtnDisabled = false
              draft.isYamadumiSimulationBtnDisabled = buildingInfo.yamadumiFlg !== 1 || buildingInfo.kenzaiDiscloseFlg !== 1
              draft.isExpenseBtnDisabled = true
              draft.isYamadumiBtnDisabled = false
              draft.isKenzaiBtnDisabled = false
              draft.isSupplierBtnDisabled = false
              draft.isCompletedBtnDisabled = false
              draft.isReportNonTargetBtnDisabled = false
            }
          } else {
            // 物件情報．支店コード≠ログイン情報．支店コード
            draft.isDelBtnDisabled = true
            draft.isSplitBtnDisabled = true
            draft.isEditBtnDisabled = false
            draft.isHistoryBtnDisabled = false
            draft.isYamadumiSimulationBtnDisabled = true
            draft.isExpenseBtnDisabled = true
            draft.isYamadumiBtnDisabled = true
            draft.isKenzaiBtnDisabled = true
            draft.isSupplierBtnDisabled = true
            draft.isCompletedBtnDisabled = true
            draft.isReportNonTargetBtnDisabled = true
            draft.isReplaceCheckDisabled = true
          }
        }
        // 物件分割許可=1の時、分割ボタンは非活性にする（分割ボタンの活性/非活性の他の判断条件よりも優先する）
        if (allowBuildingSplit === 1) {
          // 工務分割子物件
          draft.isSplitBtnDisabled = true
        }
      })
    )
  }, [
    allowBuildingSplit,
    buildingInfo.addUserKbn,
    buildingInfo.branchCd,
    buildingInfo.subNo,
    userProp?.authority,
    userProp?.branchCode
  ])

  useEffect(() => {
    const copy = createCopyBuildingInfoExceptYamadumiFlg(buildingInfo)
    setCopyBuildingInfoExceptYamadumiFlg(copy)
  }, [buildingInfo])

  useEffect(() => {
    const copy = createCopyBuildingInfoExceptKenzaiDiscloseFlg(buildingInfo)
    setCopyBuildingInfoExceptKenzaiDiscloseFlg(copy)
  }, [buildingInfo])

  useEffect(() => {
    const copy = createCopyBuildingInfoExceptSupplierDiscloseFlg(buildingInfo)
    setCopyBuildingInfoExceptSupplierDiscloseFlg(copy)
  }, [buildingInfo])

  useEffect(() => {
    setYamadumiTarget(buildingInfo.yamadumiFlg === 1)
  }, [buildingInfo.yamadumiFlg, copyBuildingInfoExceptYamadumiFlg])

  useEffect(() => {
    setPublishToKenzaibu(buildingInfo.kenzaiDiscloseFlg === 1)
  }, [buildingInfo.kenzaiDiscloseFlg, copyBuildingInfoExceptKenzaiDiscloseFlg])

  useEffect(() => {
    setPublishTofabricator(buildingInfo.supplierDiscloseFlg === 1)
  }, [buildingInfo.supplierDiscloseFlg, copyBuildingInfoExceptSupplierDiscloseFlg])

  useEffect(() => {
    // 山積ボタンの活性・非活性の制御
    // 物件情報タイプを決定する
    let buildingInfoType = ''
    if (buildingInfo.addUserKbn === String(Authority.System)) {
      // 物件情報.枝番（子）='00'
      if (buildingInfo.subNo === '00') {
        buildingInfoType = '取込物件'
      }
    } else if (buildingInfo.addUserKbn === String(Authority.Builder)) {
      if (buildingInfo.subNo === '00') {
        buildingInfoType = '工務登録物件'
      } else {
        buildingInfoType = '工務分割物件'
      }
    } else if (buildingInfo.addUserKbn === String(Authority.Material)) {
      if (buildingInfo.subNo === '00') {
        buildingInfoType = '建材部登録物件'
      }
    } else if (buildingInfo.addUserKbn === String(Authority.Branch)) {
      if (buildingInfo.subNo === '00') {
        buildingInfoType = '支店登録物件'
      } else {
        buildingInfoType = '支店分割物件'
      }
    }

    // 権限=工務の時、全物件情報タイプについて活性・非活性を判断する
    if (userProp?.authority === Authority.Builder) {
      if (buildingInfo.yamadumiFlg === 1 && buildingInfo.kenzaiDiscloseFlg === 1) {
        setBuildingSearchBtnDisabled(produce((draft) => {
          draft.isYamadumiSimulationBtnDisabled = false
        }))
      } else {
        setBuildingSearchBtnDisabled(produce((draft) => {
          draft.isYamadumiSimulationBtnDisabled = true
        }))
      }
    }

    // 権限=建材部の時、全物件情報タイプについて非活性にする
    if (userProp?.authority === Authority.Material) {
      setBuildingSearchBtnDisabled(produce((draft) => {
        draft.isYamadumiSimulationBtnDisabled = true
      }))
    }

    // 権限=支店の時、以下のように活性・非活性を判断する
    // 物件情報.支店コード = 利用者情報.支店コードの時:
    // 支店登録物件、支店分割物件は活性・非活性を判断する
    // その他の物件情報タイプは非活性にする
    // 物件情報.支店コード ≠ 利用者情報.支店コードの時:
    // 全物件情報タイプについて非活性にする
    if (userProp?.authority === Authority.Branch) {
      // 物件情報．支店コード＝ログイン情報．支店コード
      if (buildingInfo.branchCd === userProp?.branchCode) {
        if (buildingInfoType === '支店登録物件' || buildingInfoType === '支店分割物件') {
          if (buildingInfo.yamadumiFlg === 1 && buildingInfo.kenzaiDiscloseFlg === 1) {
            setBuildingSearchBtnDisabled(produce((draft) => {
              draft.isYamadumiSimulationBtnDisabled = false
            }))
          } else {
            setBuildingSearchBtnDisabled(produce((draft) => {
              draft.isYamadumiSimulationBtnDisabled = true
            }))
          }
        }
      } else {
        setBuildingSearchBtnDisabled(produce((draft) => {
          draft.isYamadumiSimulationBtnDisabled = true
        }))
      }
    }
  }, [buildingInfo.yamadumiFlg, buildingInfo.kenzaiDiscloseFlg])

  return (
    <>
      {(isDisplay ?? false) && (
      <>
      <div style={{ paddingLeft: paddingLeft() }}>
        <Tooltip position='right'>
          <Card
            orientation="horizontal"
            className={
              target === `${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}` ? 'target-card-body' : ''
            }
          >
            <CardHeader style={styleCardHeader}>
              <CardTitle style={{ marginTop: '0px' }}>
                <span
                  style={{
                    fontSize: '1.25em',
                    fontWeight: 'bold',
                    color: `${getItemColor(buildingInfo.diffFlgBranchCd)}`
                  }}
                >
                  {buildingInfo.branchNm}
                </span>
              </CardTitle>
              <CardSubtitle style={{ marginTop: '0px' }}>
                <span
                  style={{
                    fontSize: '1em',
                    fontWeight: 'bold',
                    color: 'gray'
                  }}
                >
                  {`${buildingInfo.procurementNo ?? ''}-${buildingInfo.subNo ?? ''}`}
                </span>
              </CardSubtitle>
              {isSupplier
                ? (
                <></>
                  )
                : (
                <CardSubtitle style={{ marginTop: '0px' }}>
                  <span
                    style={{
                      fontSize: '1em',
                      fontWeight: 'bold',
                      color: 'gray'
                    }}
                  >
                    {buildingInfo.buildingNo}
                  </span>
                </CardSubtitle>
                  )}
              {isSupplier
                ? (
                <></>
                  )
                : (
                <CardSubtitle style={{ marginTop: '0px' }}>
                  <span
                    style={{
                      fontSize: '1.25em',
                      fontWeight: 'bold',
                      color: `${getItemColor(buildingInfo.diffFlgEvaluationValueCd)}`
                    }}
                  >
                    {buildingInfo.evaluationValue}
                  </span>
                </CardSubtitle>
                  )}
              {isSupplier
                ? (
                <></>
                  )
                : (
                <CardSubtitle style={{ marginTop: '0px' }}>
                  <span
                    style={{
                      fontSize: '1.25em',
                      fontWeight: 'bold',
                      color: 'gray'
                    }}
                  >
                    {'選択と集中：'}
                  </span>
                  <span
                    style={{
                      fontSize: '1.25em',
                      fontWeight: 'bold',
                      color: `${getItemColor(buildingInfo.diffFlgDispChoiceAndConcentrationTarget)}`
                    }}
                  >
                    {convertFlagValue('choiceAndConcentrationTarget', buildingInfo.dispChoiceAndConcentrationTarget) ?? ''}
                  </span>
                </CardSubtitle>
                  )}
              <CardSubtitle style={{ marginTop: '0px' }}>
                <span
                  style={{
                    fontSize: '1.25em',
                    fontWeight: 'bold',
                    color: `${getUpdStsStrColor()}`
                  }}
                >
                  {buildingInfo.updStsStr}
                </span>
              </CardSubtitle>
              {isSupplier
                ? (
                <></>
                  )
                : (
                <CardSubtitle style={{ marginTop: '0px' }}>
                  <span
                    style={{
                      fontSize: '0.8em',
                      fontWeight: 'bold',
                      color: 'gray'
                    }}
                  >
                    {dayjs(buildingInfo.updDtm).format('YYYY/MM/DD HH:mm')}
                  </span>
                </CardSubtitle>
                  )}
              {isSupplier
                ? (
                <></>
                  )
                : (
                <CardSubtitle style={{ marginTop: '0px' }}>
                  <span style={{ whiteSpace: 'nowrap' }}>
                    <span
                      style={{
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        color: 'gray'
                      }}
                    >
                      {buildingInfo.updUserKbnStr}
                    </span>
                    <span
                      style={{
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        color: 'gray'
                      }}
                    >
                      /
                    </span>
                    <span
                      style={{
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        color: 'gray',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                      title={buildingInfo.updUserStr ?? ''}
                    >
                      {buildingInfo.updUserStr}
                    </span>
                  </span>
                </CardSubtitle>
                  )}
            </CardHeader>
            <CardBody style={styleCardBody}>
              <GridLayout
                gap={{ cols: 10 }}
                cols={[{ width: '70%' }, { width: '30%' }]}
              >
                <GridLayoutItem
                  col={1}
                  style={{ marginLeft: 10, marginRight: 10 }}
                >
                  <GridLayout>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={1}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {
                        buildingInfo.constructionNmDupCount > 1
                          ? <>
                              <Marker themeColor={'primary'}>
                                {/* eslint-disable-next-line react/prop-types */}
                                {'工事名重複'}
                              </Marker>
                              {' '}
                            </>
                          : <></>
                      }
                      <span
                        style={{
                          fontWeight: 'normal',
                          fontSize: '1.0em',
                          color: `${getItemColor(buildingInfo.diffFlgDispConstructionNm)}`
                        }}
                        title={buildingInfo.dispConstructionNm ?? ''}
                      >
                        {buildingInfo.dispConstructionNm}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={2}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '0.8em',
                            color: `${getItemColor(buildingInfo.diffFlgProcurementSts)}`
                          }}
                        >
                          {buildingInfo.procurementStsStr}
                        </span>
                          )
                        : (
                        <>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispConstructionSubjectCd)}`
                            }}
                          >
                            {buildingInfo.dispConstructionSubjectCd}{' '}
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgProcurementSts)}`
                            }}
                          >
                            {buildingInfo.procurementStsStr}{' '}
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispObtainHistoryCd)}`
                            }}
                          >
                            {buildingInfo.dispObtainHistoryStr}{' '}
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispConstructionFormCd)}`
                            }}
                          >
                            {buildingInfo.dispConstructionFormStr}{' '}
                          </span>
                          {
                            buildingInfo.dispOurCompanyEquityRatio !== null
                              ? <>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '0.8em',
                                      color: `${getItemColor(buildingInfo.diffFlgDispOurCompanyEquityRatio)}`
                                    }}
                                  >
                                    {buildingInfo.dispOurCompanyEquityRatio}
                                  </span>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '0.8em',
                                      color: 'gray'
                                    }}
                                  >
                                    %{' '}
                                  </span>
                                </>
                              : <></>
                          }
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispEffortLevelCd)}`
                            }}
                          >
                            {buildingInfo.dispEffortLevel}{' '}
                          </span>
                          {
                            buildingInfo.dispCoreTopFlg !== null
                              ? <>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '0.8em',
                                      color: 'gray'
                                    }}
                                  >
                                    {'コアトップ案件:'}
                                  </span>
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      fontSize: '0.8em',
                                      color: `${getItemColor(buildingInfo.diffFlgDispCoreTopFlg)}`
                                    }}
                                  >
                                    {convertFlagValue('coreTopFlg', buildingInfo.dispCoreTopFlg) ?? ''}{' '}
                                  </span>
                                </>
                              : <></>
                          }
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispObtainFy)}`
                            }}
                          >
                            {buildingInfo.dispObtainFY}{' '}
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispPrefecture)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden'
                            }}
                            title={buildingInfo.dispPrefecture ?? ''}
                          >
                            {buildingInfo.dispPrefecture}{' '}
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispCity)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden'
                            }}
                            title={buildingInfo.dispCity ?? ''}
                          >
                            {buildingInfo.dispCity}{' '}
                          </span>
                        </>
                          )}
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={3}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                        <></>
                          )
                        : (
                            <>
                              {
                                buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined
                                  ? <>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: '0.8em',
                                          color: 'gray'
                                        }}
                                      >
                                        {buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined ? '総工事金額（百万）:￥' : ''}
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: '0.8em',
                                          color: `${getItemColor(buildingInfo.diffFlgDispTotalCost)}`,
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden'
                                        }}
                                        title={
                                          buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined
                                            ? (buildingInfo.dispTotalCost / 1000000).toLocaleString()
                                            : ''
                                        }
                                      >
                                        {
                                          buildingInfo.dispTotalCost !== null && buildingInfo.dispTotalCost !== undefined
                                            ? (buildingInfo.dispTotalCost / 1000000).toLocaleString()
                                            : ''
                                        }{' '}
                                      </span>
                                    </>
                                  : <></>
                              }
                              {
                                buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined
                                  ? <>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: '0.8em',
                                          color: 'gray'
                                        }}
                                      >
                                        {buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined ? '当社概算工事金額（百万）:￥' : ''}
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: '0.8em',
                                          color: `${getItemColor(buildingInfo.diffFlgDispOurCompanyTotalCost)}`,
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden'
                                        }}
                                        title={
                                          buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined
                                            ? (buildingInfo.dispOurCompanyTotalCost / 1000000).toLocaleString()
                                            : ''
                                        }
                                      >
                                        {
                                          buildingInfo.dispOurCompanyTotalCost !== null && buildingInfo.dispOurCompanyTotalCost !== undefined
                                            ? (buildingInfo.dispOurCompanyTotalCost / 1000000).toLocaleString()
                                            : ''
                                        }
                                      </span>
                                    </>
                                  : <></>
                              }
                            </>
                          )
                      }
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={4}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispConstructionCd)}`
                        }}
                      >
                        {buildingInfo.dispConstructionStr}{' '}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgArchitectureUse)}`
                        }}
                      >
                        {buildingInfo.architectureUseStr}{' '}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        （
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispStructureUnderGround)}`
                        }}
                      >
                        {buildingInfo.dispStructureUnderGroundStr}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        /{' '}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispStructureGround)}`
                        }}
                      >
                        {buildingInfo.dispStructureGroundStr}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        ）
                      </span>
                      {
                        buildingInfo.dispTotalFloorAreaM2 !== null
                          ? <>
                            <span
                              style={{
                                fontWeight: 'bold',
                                fontSize: '0.8em',
                                color: `${getItemColor(buildingInfo.diffFlgDispTotalFloorAreaM2)}`,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden'
                              }}
                              title={buildingInfo.dispTotalFloorAreaM2?.toLocaleString() ?? ''}
                            >
                              {buildingInfo.dispTotalFloorAreaM2?.toLocaleString() }
                            </span>
                            <span
                              style={{
                                fontWeight: 'bold',
                                fontSize: '0.8em',
                                color: 'gray'
                              }}
                            >
                              ㎡
                            </span>
                          </>
                          : <></>
                      }
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        /
                      </span>
                      {
                        buildingInfo.dispTotalFloorAreaTsubo !== null
                          ? <>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: `${getItemColor(buildingInfo.diffFlgDispTotalFloorAreaTsubo)}`,
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden'
                                }}
                                title={buildingInfo.dispTotalFloorAreaTsubo?.toLocaleString() ?? ''}
                              >
                                {buildingInfo.dispTotalFloorAreaTsubo?.toLocaleString() }
                              </span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: 'gray'
                                }}
                              >
                                坪
                              </span>
                            </>
                          : <></>
                      }
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        -
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        （
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispFloorUnderGround)}`
                        }}
                      >
                        {buildingInfo.dispFloorUnderGround}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        /
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispFloorGround)}`
                        }}
                      >
                        {buildingInfo.dispFloorGround}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        /
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispFloorPentHouse)}`
                        }}
                      >
                        {buildingInfo.dispFloorPenthouse}
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        ）
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={5}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                        <></>
                          )
                        : (
                            <>
                              {
                                buildingInfo.dispBuildingServicesWorkFlg !== null
                                  ? <>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: '0.8em',
                                          color: 'gray'
                                        }}
                                      >
                                        設備工事：
                                      </span>
                                      <span
                                        style={{
                                          fontWeight: 'bold',
                                          fontSize: '0.8em',
                                          color: `${getItemColor(buildingInfo.diffFlgDispBuildingServicesWorkFlg)}`
                                        }}
                                      >
                                        {convertFlagValue(
                                          'buildingServicesWorkFlg',
                                          buildingInfo.dispBuildingServicesWorkFlg
                                        )}{' '}
                                      </span>
                                    </>
                                  : <></>
                              }
                            </>
                          )
                      }
                      {
                        buildingInfo.piling !== null
                          ? <>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: 'gray'
                                }}
                              >
                                杭打：
                              </span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: `${getItemColor(buildingInfo.diffFlgPiling)}`
                                }}
                              >
                                {convertFlagValue('piling', buildingInfo.piling)}{' '}
                              </span>
                            </>
                          : <></>
                      }
                      {
                        buildingInfo.seismicIsolation !== null
                          ? <>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: 'gray'
                                }}
                              >
                                免震：
                              </span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: `${getItemColor(buildingInfo.diffFlgSeismicIsolation)}`
                                }}
                              >
                                {convertFlagValue(
                                  'seismicIsolation',
                                  buildingInfo.seismicIsolation
                                )}{' '}
                              </span>
                            </>
                          : <></>
                      }
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgTopdown)}`
                        }}
                      >
                        {convertFlagValue('topDown', buildingInfo.topDownFlg)}{' '}
                      </span>
                      {
                        buildingInfo.dispSpecialConstructionMethod !== null
                          ? <>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: 'gray'
                                }}
                              >
                                工法：
                              </span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: `${getItemColor(buildingInfo.diffFlgDispSpecialConstructionMethod)}`,
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden'
                                }}
                                title={buildingInfo.dispSpecialConstructionMethod ?? ''}
                              >
                                {buildingInfo.dispSpecialConstructionMethod}
                              </span>
                            </>
                          : <></>
                      }
                    </GridLayoutItem>
                    <GridLayoutItem col={1} colSpan={3} row={6}>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispStartYm)}`
                        }}
                      >
                        {(buildingInfo.dispStartYM != null && buildingInfo.dispStartYM.length > 0) ? dayjs(buildingInfo.dispStartYM).format('YYYY/MM') : ''}
                      </span>
                      <span style={{ fontWeight: 'bold', fontSize: '0.8em' }}>
                        -
                      </span>
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispCompletionYm)}`
                        }}
                      >
                        {(buildingInfo.dispCompletionYM != null && buildingInfo.dispCompletionYM.length > 0) ? dayjs(buildingInfo.dispCompletionYM).format('YYYY/MM') : ''}
                      </span>
                      {
                        buildingInfo.dispSchedule !== null
                          ? <>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: `${getItemColor(buildingInfo.diffFlgDispSchedule)}`
                                }}
                              >
                                {'                '}{buildingInfo.dispSchedule ?? ''}
                              </span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: 'gray'
                                }}
                              >
                                ヶ月
                              </span>
                            </>
                          : <></>
                      }
                      <span style={{ marginLeft: '5px' }}></span>
                      {
                        buildingInfo.dispSiteAreaM2 !== null
                          ? <>
                            <span
                              style={{
                                fontWeight: 'bold',
                                fontSize: '0.8em',
                                color: `${getItemColor(buildingInfo.diffFlgDispSiteAreaM2)}`,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden'
                              }}
                              title={buildingInfo.dispSiteAreaM2?.toLocaleString() ?? ''}
                            >
                              {buildingInfo.dispSiteAreaM2?.toLocaleString() }
                            </span>
                            <span
                              style={{
                                fontWeight: 'bold',
                                fontSize: '0.8em',
                                color: 'gray'
                              }}
                            >
                              ㎡
                            </span>
                          </>
                          : <></>
                      }
                      <span
                        style={{
                          fontWeight: 'bold',
                          fontSize: '0.8em',
                          color: 'gray'
                        }}
                      >
                        /
                      </span>
                      {
                        buildingInfo.dispSiteAreaTsubo !== null
                          ? <>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: `${getItemColor(buildingInfo.diffFlgDispSiteAreaTsubo)}`,
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden'
                                }}
                                title={buildingInfo.dispSiteAreaTsubo?.toLocaleString() ?? ''}
                              >
                                {buildingInfo.dispSiteAreaTsubo?.toLocaleString() }
                              </span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '0.8em',
                                  color: 'gray'
                                }}
                              >
                                坪
                              </span>
                            </>
                          : <></>
                      }
                      <span style={{ marginLeft: '5px' }}></span>
                      {
                        buildingInfo.dispSagyosyoCd !== null
                          ? <span
                              style={{
                                fontWeight: 'bold',
                                fontSize: '0.8em',
                                color: `${getItemColor(buildingInfo.diffFlgDispSagyosyoCd)}`,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden'
                              }}
                              title={buildingInfo.dispSagyosyoCd?.toLocaleString() ?? ''}
                            >
                              {buildingInfo.dispSagyosyoCd?.toLocaleString() }
                            </span>
                          : <></>
                      }
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={7}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                        <></>
                          )
                        : (
                        <>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: 'gray'
                            }}
                          >
                            備考：
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgRemark)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden'
                            }}
                            title={buildingInfo.remark ?? ''}
                          >
                            {buildingInfo.remark}
                          </span>
                        </>
                          )}
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={1}
                      colSpan={3}
                      row={8}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                        <></>
                          )
                        : (
                        <>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: 'gray'
                            }}
                          >
                            費目：
                          </span>
                          <span
                            style={{
                              fontWeight: 'bold',
                              fontSize: '0.8em',
                              color: 'gray',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden'
                            }}
                            title={expenseString ?? ''}
                          >
                            {expenseString}
                          </span>
                        </>
                          )}
                    </GridLayoutItem>
                  </GridLayout>
                </GridLayoutItem>
                <GridLayoutItem col={2}>
                  <GridLayout
                    gap={{ cols: 1 }}
                    rows={[
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' },
                      { height: '1.0em' }
                    ]}
                    cols={[{ width: '40%' }, { width: '60%' }]}
                  >
                    <GridLayoutItem col={1} row={1}>
                      <span
                        style={{
                          fontSize: '0.8em',
                          verticalAlign: 'top'
                        }}
                      >
                        工事部
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={1}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispConstructionSectionNm)}`,
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          verticalAlign: 'top'
                        }}
                        title={buildingInfo.dispConstructionSectionNm ?? ''}
                      >
                        {buildingInfo.dispConstructionSectionNm}
                      </span>
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: 'gray',
                          verticalAlign: 'top'
                        }}
                      >
                        ）
                      </span>
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispChiefPersonNm)}`,
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          verticalAlign: 'top'
                        }}
                        title={buildingInfo.dispChiefPersonNm ?? ''}
                      >
                        {buildingInfo.dispChiefPersonNm}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={2}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                          <></>
                          )
                        : (
                            <span
                              style={{
                                fontSize: '0.8em',
                                color: `${getItemColor(buildingInfo.diffFlgDispChiefPersonContacts)}`,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                verticalAlign: 'top'
                              }}
                              title={buildingInfo.dispChiefPersonContacts ?? ''}
                            >
                              {buildingInfo.dispChiefPersonContacts}
                            </span>
                          )}
                    </GridLayoutItem>
                    <GridLayoutItem col={1} row={3}>
                      <span
                        style={{
                          fontSize: '0.8em',
                          verticalAlign: 'top'
                        }}
                      >
                        本社営業部
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={3}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispHqSalesSectionNm)}`,
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          verticalAlign: 'top'
                        }}
                        title={buildingInfo.dispHqSalesSectionNm ?? ''}
                      >
                        {buildingInfo.dispHqSalesSectionNm}
                      </span>
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: 'gray',
                          verticalAlign: 'top'
                        }}
                      >
                        ）
                      </span>
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispHqSalesPersonNm)}`,
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          verticalAlign: 'top'
                        }}
                        title={buildingInfo.dispHqSalesPersonNm ?? ''}
                      >
                        {buildingInfo.dispHqSalesPersonNm}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={4}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                          <></>
                          )
                        : (
                            <span
                              style={{
                                fontSize: '0.8em',
                                color: `${getItemColor(buildingInfo.diffFlgDispHqSalesPersonContacts)}`,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                verticalAlign: 'top'
                              }}
                              title={buildingInfo.dispHqSalesPersonContacts ?? ''}
                            >
                              {buildingInfo.dispHqSalesPersonContacts}
                            </span>
                          )}
                    </GridLayoutItem>
                    <GridLayoutItem col={1} row={5}>
                      <span
                        style={{
                          fontSize: '0.8em',
                          verticalAlign: 'top'
                        }}
                      >
                        支店営業部
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={5}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispBranchSalesSectionNm)}`,
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          verticalAlign: 'top'
                        }}
                        title={buildingInfo.dispBranchSalesSectionNm ?? ''}
                      >
                        {buildingInfo.dispBranchSalesSectionNm}
                      </span>
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: 'gray',
                          verticalAlign: 'top'
                        }}
                      >
                        ）
                      </span>
                      <span
                        style={{
                          fontSize: '0.8em',
                          color: `${getItemColor(buildingInfo.diffFlgDispBranchSalesPersonNm)}`,
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          verticalAlign: 'top'
                        }}
                        title={buildingInfo.dispBranchSalesPersonNm ?? ''}
                      >
                        {buildingInfo.dispBranchSalesPersonNm}
                      </span>
                    </GridLayoutItem>
                    <GridLayoutItem
                      col={2}
                      row={6}
                      style={{
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }}
                    >
                      {isSupplier
                        ? (
                        <></>
                          )
                        : (
                          <span
                            style={{
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispBranchSalesPersonContacts)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              verticalAlign: 'top'
                            }}
                            title={buildingInfo.dispBranchSalesPersonContacts ?? ''}
                          >
                          {buildingInfo.dispBranchSalesPersonContacts}
                        </span>
                          )}
                    </GridLayoutItem>
                    {isSupplier
                      ? (
                        <></>
                        )
                      : (
                          <>
                        <GridLayoutItem col={1} row={7}>
                          <span
                            style={{
                              fontSize: '0.8em',
                              verticalAlign: 'top'
                            }}
                          >
                            発注者
                          </span>
                        </GridLayoutItem>
                        <GridLayoutItem
                          col={2}
                          row={7}
                          style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                          }}
                        >
                          <span
                            style={{
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispCustomerNm)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              verticalAlign: 'top'
                            }}
                            title={buildingInfo.dispCustomerNm ?? ''}
                          >
                            {buildingInfo.dispCustomerNm}
                          </span>
                          <span
                            style={{
                              fontSize: '0.8em',
                              color: 'gray',
                              verticalAlign: 'top'
                            }}
                          >
                            {' '}
                          </span>
                          <span
                            style={{
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispCollabCustomerNm)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              verticalAlign: 'top'
                            }}
                            title={buildingInfo.dispCollabCustomerNm ?? ''}
                          >
                            {buildingInfo.dispCollabCustomerNm}
                          </span>
                        </GridLayoutItem>
                        <GridLayoutItem col={1} row={8}>
                          <span
                            style={{
                              fontSize: '0.8em',
                              verticalAlign: 'top'
                            }}
                          >
                            設計
                          </span>
                        </GridLayoutItem>
                        <GridLayoutItem col={2} row={8}>
                          <span
                            style={{
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispDesignKbn)}`,
                              verticalAlign: 'top'
                            }}
                          >
                            {buildingInfo.dispDesignKbnNm}
                          </span>
                        </GridLayoutItem>
                        <GridLayoutItem
                          col={2}
                          row={9}
                          style={{
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                          }}
                        >
                          <span
                            style={{
                              fontSize: '0.8em',
                              color: `${getItemColor(buildingInfo.diffFlgDispDesignerNm)}`,
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              verticalAlign: 'top'
                            }}
                            title={buildingInfo.dispDesignerNm ?? ''}
                          >
                            {buildingInfo.dispDesignerNm}
                          </span>
                        </GridLayoutItem>
                      </>
                        )}
                  </GridLayout>
                </GridLayoutItem>
              </GridLayout>
            </CardBody>
            {isSupplier
              ? (
                <></>
                )
              : (
                <CardFooter style={{ padding: '1% 1%' }}>
                <GridLayout gap={{ rows: '0px', cols: '10px' }}>
                  <GridLayoutItem col={1}>
                    <GridLayout gap={{ rows: '3px', cols: '0px' }}>
                      <GridLayoutItem col={1} row={1}>
                        <Button
                          onClick={toggleHistoryDialog}
                          themeColor="secondary"
                          fillMode="flat"
                          disabled={buildingSearchBtnDisabled.isHistoryBtnDisabled}
                          style={{ padding: '0px 8px' }}
                        >
                          履歴
                        </Button>
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={2}>
                        <Button
                          onClick={toggleMaintenanceDialog}
                          themeColor="secondary"
                          fillMode="flat"
                          disabled={buildingSearchBtnDisabled.isEditBtnDisabled}
                          style={{ padding: '0px 8px' }}
                        >
                          編集
                        </Button>
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={3}>
                        <Button
                          onClick={toggleSplitDialog}
                          themeColor="secondary"
                          fillMode="flat"
                          disabled={buildingSearchBtnDisabled.isSplitBtnDisabled}
                          style={{ padding: '0px 8px' }}
                        >
                          分割
                        </Button>
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={4}>
                        <Button
                          themeColor="secondary"
                          onClick={handleYamadumiSimulation}
                          fillMode="flat"
                          disabled={buildingSearchBtnDisabled.isYamadumiSimulationBtnDisabled}
                          style={{ padding: '0px 8px' }}
                        >
                          山積
                        </Button>
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={5}>
                        <Button
                          themeColor="secondary"
                          onClick={toggleExpenseDialog}
                          fillMode="flat"
                          disabled={buildingSearchBtnDisabled.isExpenseBtnDisabled}
                          style={{ padding: '0px 8px' }}
                        >
                          費目
                        </Button>
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={6}>
                        <Button
                          themeColor="secondary"
                          onClick={handleDelete}
                          fillMode="flat"
                          disabled={buildingSearchBtnDisabled.isDelBtnDisabled}
                          style={{ padding: '0px 8px' }}
                        >
                          削除
                        </Button>
                      </GridLayoutItem>
                    </GridLayout>
                  </GridLayoutItem>
                  <GridLayoutItem col={2}>
                    <GridLayout gap={{ rows: '5px', cols: '5px' }}>
                      <GridLayoutItem col={1} row={1}>
                        <span style={{ fontSize: '0.8em' }}>山積対象</span>
                      </GridLayoutItem>
                      <GridLayoutItem col={2} row={1}>
                        <Switch
                          size={'small'}
                          checked={yamadumiTarget}
                          onChange={toggleYamadumiTarget}
                          disabled={buildingSearchBtnDisabled.isYamadumiBtnDisabled}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={2}>
                        <span style={{ fontSize: '0.8em' }}>建材部公開</span>
                      </GridLayoutItem>
                      <GridLayoutItem col={2} row={2}>
                        <Switch
                          size={'small'}
                          checked={publishToKenzaibu}
                          onChange={togglePublishToKenzaibu}
                          disabled={buildingSearchBtnDisabled.isKenzaiBtnDisabled}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={3}>
                        <span style={{ fontSize: '0.8em' }}>業者公開</span>
                      </GridLayoutItem>
                      <GridLayoutItem col={2} row={3}>
                        <Switch
                          size={'small'}
                          checked={publishTofabricator}
                          onChange={handlePublishTofabricatorToggle}
                          disabled={buildingSearchBtnDisabled.isSupplierBtnDisabled}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={4}>
                        <span style={{ fontSize: '0.8em' }}>竣工済</span>
                      </GridLayoutItem>
                      <GridLayoutItem col={2} row={4}>
                        <Switch
                          size={'small'}
                          checked={completed}
                          onChange={ToggleCompleted}
                          disabled={buildingSearchBtnDisabled.isCompletedBtnDisabled}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem col={1} row={5}>
                        <span style={{ fontSize: '0.8em' }}>帳票対象外</span>
                      </GridLayoutItem>
                      <GridLayoutItem col={2} row={5}>
                        <Switch
                          size={'small'}
                          checked={reportNonTarget}
                          onChange={ToggleReportNonTarget}
                          disabled={buildingSearchBtnDisabled.isReportNonTargetBtnDisabled}
                        />
                      </GridLayoutItem>
                      {isSupplier
                        ? (
                          <></>
                          )
                        : (
                          <>
                            <GridLayoutItem col={1} row={6}>
                              <span style={{ fontSize: '0.8em' }}>付替元</span>
                            </GridLayoutItem>
                            <GridLayoutItem col={2} row={6} style={{ textAlign: 'center' }}>
                              <Checkbox
                                disabled={buildingSearchBtnDisabled.isReplaceCheckDisabled || buildingInfo.subNo !== '00'}
                                checked={checkBuilding(buildingInfo, sourceBuilding)}
                                onChange={(e) => { handleCheckBuilding(buildingInfo, 'sourceBuilding', e.value) }}
                              />
                            </GridLayoutItem>
                            <GridLayoutItem col={1} row={7}>
                              <span style={{ fontSize: '0.8em' }}>付替先</span>
                            </GridLayoutItem>
                            <GridLayoutItem col={2} row={7} style={{ textAlign: 'center' }}>
                              <Checkbox
                                disabled={buildingSearchBtnDisabled.isReplaceCheckDisabled || buildingInfo.subNo !== '00'}
                                checked={checkBuilding(buildingInfo, destinationBuilding)}
                                onChange={(e) => { handleCheckBuilding(buildingInfo, 'destinationBuilding', e.value) }}
                              />
                            </GridLayoutItem>
                          </>
                          )}
                      {buildingInfo.subNo === '00' && isExistChildren && (
                        <GridLayoutItem col={1} colSpan={2} row={8}>
                          <div style={{ textAlign: 'right' }}>
                            <Button
                              onClick={handleExpand}
                              themeColor="secondary"
                              fillMode="flat"
                            >
                              {isExpanded ? '子物件非表示' : '子物件表示'}
                            </Button>
                          </div>
                        </GridLayoutItem>
                      )}
                    </GridLayout>
                  </GridLayoutItem>
                </GridLayout>
              </CardFooter>
                )}
          </Card>
        </Tooltip>
      </div>

      {showSplitDialog && (
        <Window
          title={'物件情報メンテナンス　分割'}
          onClose={toggleSplitDialogReturn}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <BuildingSplit
            key={`${buildingInfoPutState.procurementNo ?? ''}-${buildingInfoPutState.subNo ?? ''}`}
            pageType={1}
            params={{
              branchCd: buildingInfo.branchCd ?? '',
              subNo: buildingInfo.subNo ?? '',
              procurementNo: buildingInfo.procurementNo ?? '',
              expenseCode: '',
              expenseSeq: ''
            }}
            buildingInfoSplitList={buildingInfoSplitListState}
            setBuildingInfoSplitList={setBuildingInfoSplitListState}
            setSignInBtnDisabled={setBuildingMaintenanceSignInBtnDisabled}
          />
          <StackLayout
            orientation="horizontal"
            align={{ horizontal: 'end' }}
            gap={5}
          >
            <Button
              className="pcy-button-long"
              onClick={toggleSplitDialogReturn}
            >
              戻る
            </Button>
            <Button
              className="pcy-button-long"
              themeColor="primary"
              disabled={buildingInfoSplitListState.length === 0}
              onClick={toggleSplitDialogLogin}
            >
              登録
            </Button>
          </StackLayout>
        </Window>
      )}

      {showMaintenanceDialog && (
        <Window
          title={'物件情報メンテナンス　編集'}
          onClose={toggleMaintenanceDialogReturn}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <BuildingMaintenance
            key={`${buildingInfoPutState.procurementNo ?? ''}-${buildingInfoPutState.subNo ?? ''}`}
            pageType={0}
            params={{
              branchCd: buildingInfo.branchCd ?? '',
              subNo: buildingInfo.subNo ?? '',
              procurementNo: buildingInfo.procurementNo ?? '',
              expenseCode: '',
              expenseSeq: ''
            }}
            buildingInfoPut={buildingInfoPutState}
            buildingInfoPutStore={buildingInfoPutStore}
            setBuildingInfoPut={setBuildingInfoPutState}
            setBuildingInfoPutStore={setBuildingInfoPutStore}
            setSignInBtnDisabled={setBuildingMaintenanceSignInBtnDisabled}
          />
          <StackLayout
            orientation="horizontal"
            align={{ horizontal: 'end' }}
            gap={5}
          >
            <Button
              className="pcy-button-long"
              onClick={toggleMaintenanceDialogReturn}
            >
              戻る
            </Button>
            <Button
              className="pcy-button-long"
              themeColor="primary"
              onClick={toggleMaintenanceDialogLogin}
              disabled={buildingMaintenanceSignInBtnDisabled}
            >
              登録
            </Button>
          </StackLayout>
        </Window>
      )}

      {showHistoryDialog && (
        <Window
          title={'物件情報履歴一覧'}
          onClose={toggleHistoryDialog}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <BuildingHistory
            footerButtonEvent={() => toggleHistoryDialog()}
            procurementNo={buildingInfo.procurementNo ?? ''}
            subNo={buildingInfo.subNo ?? ''}
          />
        </Window>
      )}

      {showExpenseDialog && (
        <Window
          title={'物件情報メンテナンス　費目要否'}
          onClose={toggleExpenseDialogReturn}
          initialWidth={1280}
          initialHeight={500}
          modal
        >
          <BuildingExpense
            buildingInfo={buildingInfo}
            expenseInfos={buildingInfo.expenseInfos}
            expenseInfoPutState={expenseInfoPutState}
            setExpenseInfoPutState={setExpenseInfoPutState}
          />
          <StackLayout
            orientation="horizontal"
            align={{ horizontal: 'end' }}
            gap={5}
          >
            <Button
              className="pcy-button-long"
              onClick={toggleExpenseDialogReturn}
            >
              戻る
            </Button>
            <Button
              className="pcy-button-long"
              themeColor="primary"
              disabled={ExpenseCompare()}
              onClick={toggleExpenseDialogLogin}
            >
              登録
            </Button>
          </StackLayout>
        </Window>
      )}

      {confirmDialogShow && (
        <ConfirmDialog
          open={confirmDialogShow}
          title={title}
          id={confirmDialogId}
          args={args}
          onClickOk={handleConfirmEvent}
          onClickCancel={() => setConfirmDialogShow(false)}
        />
      )}
      </>
      )}
    </>
  )
}
